import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Injectable()
export class BaseComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  get subs(): Subscription | Subscription[] {
    return this.subscriptions;
  }

  set subs(sub: Subscription | Subscription[]) {
    if (sub) {
      if (sub instanceof Subscription) {
        this.subscriptions.push(sub);
      } else {
        this.subscriptions = this.subscriptions.concat(sub);
      }
    }
  }

  destroy$ = new Subject<void>();

  protected unsubscribeAll(): void {
    for (const sub of this.subscriptions) {
      if (sub) {
        sub.unsubscribe();
      }
    }
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();

    this.destroy$.next();
    this.destroy$.complete();
  }
}
